import Vue from 'vue'

export function toastInfo(message) {

  let toast = Vue.toasted.show(message, {
    position: "top-center",
    duration: 3000,
    theme: 'primary'
  })    
}

export function toastError(message) {

  let toast = Vue.toasted.show(message, {
    position: "top-center",
    duration: 5000,
    theme: 'bubble'
  })    
}